import { render } from "./KuponJajanMMS.vue?vue&type=template&id=8bb88770"
import script from "./KuponJajanMMS.vue?vue&type=script&lang=js"
export * from "./KuponJajanMMS.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__